import { pisaWhoAmIDataItem } from './Pisa/pisaWhoAmIDataItem'

export const WhoAmI = pisaWhoAmIDataItem()
